import { render, staticRenderFns } from "./BmiCalculator.vue?vue&type=template&id=23244113&scoped=true"
import script from "./BmiCalculator.vue?vue&type=script&lang=js"
export * from "./BmiCalculator.vue?vue&type=script&lang=js"
import style0 from "./BmiCalculator.vue?vue&type=style&index=0&id=23244113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23244113",
  null
  
)

export default component.exports